import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  RewardPointsManagementComponent,
} from '../../components';
import config from '../../config';
import './rewardpointmanagement.global.scss';

interface Props {
  intl: any;
  scrollingDisabled: any;
}

const RewardPointManagement: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'Rolemanagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <RewardPointsManagementComponent />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const RewardPointManagementComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(RewardPointManagement);

export default RewardPointManagementComponentPage;
